import { useState } from "react";
import type { HistoryPoint } from "../history/history";
import type { MemberRow } from "./liveCircle";
import { travelGroups, type TravelGroup } from "./together";
import { sameGroups } from "./togetherView";

const NONE: TravelGroup[] = [];

/**
 * Members travelling together (`travelGroups`), each result passed back as the
 * next one's `previous` for its hysteresis. Detection does not run while
 * `enabled` is false ("Group people travelling together" off): no groups. An
 * unchanged result keeps the previous array.
 */
export function useTravelGroups(
  rows: readonly MemberRow[],
  tracks: ReadonlyMap<string, readonly HistoryPoint[]>,
  nowMs: number,
  enabled: boolean,
): readonly TravelGroup[] {
  const [state, setState] = useState({ rows, tracks, nowMs, enabled, groups: NONE });
  if (state.rows === rows && state.tracks === tracks && state.nowMs === nowMs && state.enabled === enabled) {
    return state.groups;
  }
  // Computed during render from the last result (React's "adjusting state when a prop changes").
  const next = enabled ? travelGroups(rows, tracks, nowMs, state.groups) : NONE;
  const groups = sameGroups(next, state.groups) ? state.groups : next;
  setState({ rows, tracks, nowMs, enabled, groups });
  return groups;
}
